"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const GlobalCounter_1 = tslib_1.__importDefault(require("./GlobalCounter"));
const HTMLUtils_1 = tslib_1.__importDefault(require("./HTMLUtils"));
class InterpolatedTemplate {
    // we might need to escape dangerously set innerHTML, but since this is only allowed in require,
    // then it's probably not necessary
    constructor(htmlString) {
        this.interpolatedTextNodes = {};
        const wrapper = document.createElement("div");
        wrapper.innerHTML = HTMLUtils_1.default.sanitizeHTML(htmlString, {
            SANITIZE_DOM: false
        });
        const allInterpolatedNodes = this.findAllInterpolatedTextNodes(wrapper);
        const allElements = this.findAllElementsWithIdsAndLabel(wrapper);
        // Extremely frequent constructor, use optimal iterable
        for (const interpolatedNode of allInterpolatedNodes) {
            const parent = interpolatedNode.parentNode;
            if (parent && interpolatedNode.textContent) {
                const textArray = interpolatedNode.textContent.match(InterpolatedTemplate.splitTextNodeByInterpolation);
                parent.removeChild(interpolatedNode);
                if (textArray) {
                    for (const text of textArray) {
                        const textNode = document.createTextNode("");
                        if (text.startsWith("$")) {
                            const variable = text.substring(2, text.length - 1);
                            this.interpolatedTextNodes[variable] = textNode;
                        }
                        parent.appendChild(textNode);
                    }
                }
            }
        }
        for (const htmlElement of allElements.elements) {
            const elementId = htmlElement.id;
            if (elementId) {
                this.interpolatedTextNodes[elementId] = htmlElement;
                htmlElement.id = `${allElements.idReferences[elementId]}`;
            }
        }
        for (const label of allElements.labels) {
            const labelFor = label.htmlFor;
            if (labelFor) {
                label.htmlFor = `${allElements.idReferences[labelFor]}`;
            }
            const elementId = label.id;
            if (elementId) {
                this.interpolatedTextNodes[elementId] = label;
                label.id = `${allElements.idReferences[elementId]}`;
            }
        }
        this.element = wrapper.firstElementChild;
    }
    getElement() {
        return this.element;
    }
    getInterpolatedTextNodes() {
        return this.interpolatedTextNodes;
    }
    /**
     * Method can be improved to O(n)
     * @param wrapperElement
     */
    findAllInterpolatedTextNodes(wrapperElement) {
        const walker = document.createTreeWalker(wrapperElement, NodeFilter.SHOW_TEXT, node => {
            if (!node.textContent) {
                return NodeFilter.FILTER_REJECT;
            }
            if (!InterpolatedTemplate.hasInterpolationRegExp.test(node.textContent)) {
                return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
        });
        const textNodes = [];
        while (walker.nextNode()) {
            textNodes.push(walker.currentNode);
        }
        return textNodes;
    }
    /**
     * Method can be improved to O(n)
     * @param wrapperElement
     */
    findAllElementsWithIdsAndLabel(wrapperElement) {
        const elements = [];
        const labels = [];
        const idReferences = {};
        const nodeIterator = document.createNodeIterator(wrapperElement, NodeFilter.SHOW_ELEMENT, node => {
            if (node instanceof HTMLLabelElement && !!node.htmlFor) {
                return NodeFilter.FILTER_ACCEPT;
            }
            if (node instanceof Element && !!node.id) {
                return NodeFilter.FILTER_ACCEPT;
            }
            return NodeFilter.FILTER_REJECT;
        });
        let currentNode = nodeIterator.nextNode();
        while (currentNode) {
            if (currentNode instanceof HTMLLabelElement) {
                if (currentNode.id) {
                    idReferences[currentNode.id] = GlobalCounter_1.default.next();
                }
                labels.push(currentNode);
            }
            else if (currentNode instanceof Element) {
                idReferences[currentNode.id] = GlobalCounter_1.default.next();
                elements.push(currentNode);
            }
            currentNode = nodeIterator.nextNode();
        }
        return {
            elements,
            idReferences,
            labels
        };
    }
}
InterpolatedTemplate.hasInterpolationRegExp = /\${.+}/;
InterpolatedTemplate.splitTextNodeByInterpolation = /(\${.+?})|([A-Za-z0-9]+)/gm;
exports.default = InterpolatedTemplate;
//# sourceMappingURL=InterpolatedTemplate.js.map